import authorizedAPIInstance from '@/api/authorizedAPI';
import { formatAPIError } from '@/utils/helpers';
import type {
  ProductionPeriod,
  ProductionPeriodListResponse,
} from '../utils/types';

export type FetchProductionPeriodsInput = {
  plant: string;
  facility_id: string;
  date: string;
};

export const fetchProductionPeriods = async (
  params: FetchProductionPeriodsInput
): Promise<ProductionPeriodListResponse> => {
  try {
    const { data } =
      await authorizedAPIInstance.get<ProductionPeriodListResponse>(
        '/api/production-periods',
        { params }
      );
    return data;
  } catch (error) {
    throw formatAPIError(error);
  }
};

export const fetchProductionPeriod = async (
  id: string
): Promise<ProductionPeriod> => {
  try {
    const { data } = await authorizedAPIInstance.get<ProductionPeriod>(
      `/api/production-periods/${id}`
    );
    return data;
  } catch (error) {
    throw formatAPIError(error);
  }
};

export type CreateProductionPeriodInput = {
  plant: string;
  facility_id: string;
  material_code: string;
  date: string;
  is_24_hour_production: boolean;
  start_time: string;
  end_time: string;
};

export type UpdateProductionPeriodInput = {
  is_24_hour_production: boolean;
  start_time: string;
  end_time: string;
};

export type CreateProductionPeriodResponse = {
  id: string;
  message: string;
};

export type UpdateProductionPeriodResponse = {
  id: string;
  message: string;
};

export type DeleteProductionPeriodResponse = {
  status: 'DELETED';
  id: string;
};

export const createProductionPeriod = async (
  body: CreateProductionPeriodInput
): Promise<CreateProductionPeriodResponse> => {
  try {
    const { data } =
      await authorizedAPIInstance.post<CreateProductionPeriodResponse>(
        '/api/production-periods',
        body
      );
    return data;
  } catch (error) {
    throw formatAPIError(error);
  }
};

export const updateProductionPeriod = async (
  id: string,
  body: UpdateProductionPeriodInput
): Promise<UpdateProductionPeriodResponse> => {
  try {
    const { data } =
      await authorizedAPIInstance.patch<UpdateProductionPeriodResponse>(
        `/api/production-periods/${id}`,
        body
      );
    return data;
  } catch (error) {
    throw formatAPIError(error);
  }
};

export const deleteProductionPeriod = async (
  id: string
): Promise<DeleteProductionPeriodResponse> => {
  try {
    const { data } =
      await authorizedAPIInstance.delete<DeleteProductionPeriodResponse>(
        `/api/production-periods/${id}`
      );
    return data;
  } catch (error) {
    throw formatAPIError(error);
  }
};
